import {useEffect, useState} from 'react'
import {useSelector} from '../../store.js'
import {warehouseFiltersSelector} from './analyticsSelectors.js'
import WarehouseFilter from '../../common/components/WarehouseFilter.js'
import handleListSelection from '../../common/handleListSelection.js'
import {setWarehouseFilters} from './analyticsActions.js'
import {FILTER_SELECT_ALL} from '../../common/components/FilterDropdown.js'

export async function handleAnalyticsWarehouseListSelection({
  option,
  event,
  list,
  selectedIDs,
  setSelectedIDs,
  lastSelectedID,
  setLastSelectedID,
}) {
  list = list
    .filter(({type}) => type !== FILTER_SELECT_ALL)
    .map(({entity: {id}}) => id)

  if (option.type === FILTER_SELECT_ALL) {
    setSelectedIDs(selectedIDs.length === list.length ? [] : list)

    return
  }

  const warehouseID = option.entity.id

  setSelectedIDs(
    handleListSelection({
      value: warehouseID,
      isSelected: event
        ? event.target.checked
        : !selectedIDs.includes(warehouseID),
      isShiftKey: event?.shiftKey,
      selected: selectedIDs,
      list,
      previousValue: lastSelectedID,
    }),
  )

  setLastSelectedID(warehouseID)
}

export default function AnalyticsWarehouseFilter() {
  const warehouseFilters = useSelector(warehouseFiltersSelector)
  const [selectedIDs, setSelectedIDs] = useState([])
  const [lastSelectedID, setLastSelectedID] = useState(null)

  useEffect(() => {
    setSelectedIDs(warehouseFilters)
  }, [warehouseFilters])

  return (
    <WarehouseFilter
      label="Filter by Warehouse"
      dropdown="analytics_warehouse_filter"
      value={selectedIDs}
      onSelect={(option, event, list) =>
        handleAnalyticsWarehouseListSelection({
          option,
          event,
          list,
          selectedIDs,
          setSelectedIDs,
          lastSelectedID,
          setLastSelectedID,
        })
      }
      onChange={() => setWarehouseFilters(selectedIDs)}
      includeSelectAll
    />
  )
}
